(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .controller('BagReadyModalController', BagReadyModalController);

    /** @ngInject */
    function BagReadyModalController($rootScope, $localStorage, $state, $window, $uibModalInstance, $translate, toastr,
                                     BagService, ModalFactory, ShowcasesService, createdBag, systemConstants) {
        var vm = this;

        vm.isImmoContext = $localStorage.defaultStore.immoContext;

        vm.$onInit = init;

        vm.sendToWhatsApp = sendToWhatsApp;
        vm.generateTabloid = generateTabloid;
        vm.getTranslateKey = function (key) {
            return getTranslateKey(vm.isImmoContext, key);
        }
        vm.closeModal = closeModal;

        function init() {
            vm.bag = createdBag;
            vm.bagUrl = BagService.getBagUrl(createdBag);
            createdBag.whatsappText = BagService.getBagWhatsAppText(createdBag);

            vm.imageUrl = getEmptyImageURL();
        }

        function sendToWhatsApp() {
            BagService.sendToWhatsApp(createdBag);
        }

        function generateTabloid() {
            ShowcasesService.getShowcase(createdBag.id).then(function (response) {
                var bag = response;
                if (!bag.hasCover) {
                    toastr.error($translate.instant('showcases.messages.errors.blankCover'));
                    vm.isSaving = false;
                } else if (bag.flyers.length < 1) {
                    toastr.warning($translate.instant(vm.getTranslateKey('bag.error.no-products')));
                } else if (!bag.name) {
                    toastr.error($translate.instant('showcases.messages.errors.blankName'));
                } else {
                    vm.isPrinting = true;
                    buildMessageGeneratedTabloid(bag);
                    $rootScope.$emit('waiting-generates-tabloid');
                    ShowcasesService.generateTabloid({
                        showcaseId: Number(bag.id) || undefined,
                        storeId: ( $localStorage.defaultStore ? $localStorage.defaultStore.storeId + "" : undefined) || undefined,
                        flyers: []
                    }).then(succesPrint, errorPrint);
                }
            })
        }

        function buildMessageGeneratedTabloid(bag) {
            ModalFactory.openModal(null,
                vm.getTranslateKey('bag.info.preparing-bag'),
                null, null, 'OK', null, 'close',null, null, null,
                'showcases.messages.tabloid.ifNotDownloaded', 'showcases.messages.tabloid.clickHere',
                function(callback){
                    ShowcasesService.generateTabloid({
                        showcaseId: Number(bag.id) || undefined,
                        storeId: ( $localStorage.defaultStore ? $localStorage.defaultStore.storeId + "" : undefined) || undefined,
                        flyers: []
                    }).then(succesPrint, errorPrint);
                }, 'width: 40%;', getEmptyImageURL());
        }

        function succesPrint(res) {
            if (res.headers["content-disposition"]){
                var filename = res.headers["content-disposition"].match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1];
                var mimeType = res.headers["content-type"];
                filename = filename.replace(/['"]/g, '');
                saveByteArray([res.data], filename, mimeType);
            } else {
                toastr.error($translate.instant('showcases.messages.tabloid.error.erroByGenerateCatalog'));
            }

            vm.isPrinting = false;
            $rootScope.$emit('finish-generate-tabloid');
        }

        function errorPrint(response) {
            vm.isPrinting = false;
            $rootScope.$emit('finish-generate-tabloid');
            toastr.error($translate.instant('showcases.messages.tabloid.error.erroByGenerateCatalog'));
        }

        function closeModal() {
            $uibModalInstance.dismiss('cancel');
            $state.go('bag', {
                showcaseId: createdBag.id
            });
        }

        function getEmptyImageURL() {
            var url = systemConstants.SYSTEM_IMAGES_BASE_URL + $rootScope.urlImage;
            if (vm.isImmoContext) {
                return url + '/Catalogos.png';
            } else {
                return url + '/mala-m.png';
            }
        }
    }
})();
